/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SddcProviders } from './sddcProviders';
import { DataCentersEnum } from './dataCentersEnum';


export interface CloudProviderRegion { 
    /**
     * Region id
     */
    id: string;
    /**
     * Short region id
     */
    short_id?: string;
    /**
     * Region name
     */
    name: string;
    data_center?: DataCentersEnum;
    availability_zones?: Array<string>;
    /**
     * List of SDDC providers
     */
    sddc_providers?: Array<SddcProviders>;
}
export namespace CloudProviderRegion {
}


